<template></template>
<script>
export default {
  data() {
    let vm = this;
    return {
      element: null,
      resources: {
        showTitle: {
          name: 'showTitle',
          defaultValue: true,
          labelDesc: 'instagram-show-header',
          callback: function () {
            vm.resources.showTitle.defaultValue = this.value;
            vm.element.internal_config.showHeader = this.value;
          },
        },
        showDescription: {
          name: 'showDescription',
          defaultValue: true,
          labelDesc: 'instagram-show-engagement',
          callback: function () {
            vm.resources.showDescription.defaultValue = this.value;
            vm.element.internal_config.showEngagement = this.value;
            vm.element.internal_config.hoverEffectsEnabled = this.value;
          },
        },
        columns: {
          name: 'columns',
          defaultValue: 3,
          min: 1,
          max: 6,
          labelDesc: 'number-of-columns',
          callback: function () {
            vm.resources.columns.defaultValue = this.value;
            vm.element.internal_config.columns = parseInt(this.value, 10) || 3;
          },
        },
        imagesPerPage: {
          name: 'imagesPerPage',
          defaultValue: 9,
          min: 1,
          max: 30,
          labelDesc: 'number-of-posts',
          callback: function () {
            vm.resources.imagesPerPage.defaultValue = this.value;
            vm.element.internal_config.postsPerPage = parseInt(this.value, 10) || 9;
          },
        },
        maxWidth: {
          name: 'maxWidth',
          defaultValue: '900',
          min: '320',
          max: '1200',
          labelDesc: 'max-width-tablet',
          callback: function () {
            vm.resources.maxWidth.defaultValue = this.value;
            vm.element.internal_config.maxWidth = this.value + 'px';
          },
        },
      },
    };
  },
  methods: {
    setValuesData(element) {
      this.element = element;
      this.resources.showTitle.defaultValue = !!element.internal_config.showHeader;
      this.resources.showDescription.defaultValue = typeof element.internal_config.hoverEffectsEnabled !== 'undefined'
        ? !!element.internal_config.hoverEffectsEnabled
        : !!element.internal_config.showEngagement;
      this.resources.columns.defaultValue = parseInt(element.internal_config.columns, 10) || 3;
      this.resources.imagesPerPage.defaultValue = parseInt(element.internal_config.postsPerPage, 10) || 9;
      if (typeof element.internal_config.maxWidth !== 'undefined') {
        this.resources.maxWidth.defaultValue = String(element.internal_config.maxWidth).replace('px', '');
      }
    },
    getValuesData() {
      return this.resources;
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/editor/apps/InstagramFeed/Resources.vue